
import { URLS } from '../constants'
import { GET_COMPANY_CUSTOMERS_BEGIN, GET_COMPANY_CUSTOMERS_FAILURE, GET_COMPANY_CUSTOMERS_SUCCESS, GET_COMPANY_CUSTOMER_BEGIN, GET_COMPANY_CUSTOMER_FAILURE, GET_COMPANY_CUSTOMER_SUCCESS, SET_COMPANY_CUSTOMER_QUERY } from '../constants/ActionTypes'

import { dispatchFetchGet, setUrlSearchParams } from './ActionUtil'

// Get Company Customer
const acGetCompanyCustomersBegin = () => ({ type: GET_COMPANY_CUSTOMERS_BEGIN })
const acGetCompanyCustomersSuccess = data => ({ type: GET_COMPANY_CUSTOMERS_SUCCESS, payload: data })
const acGetCompanyCustomersFailure = err => ({ type: GET_COMPANY_CUSTOMERS_FAILURE, payload: err })

const acGetCompanyCustomerBegin = () => ({ type: GET_COMPANY_CUSTOMER_BEGIN })
const acGetCompanyCustomerSuccess = data => ({ type: GET_COMPANY_CUSTOMER_SUCCESS, payload: data })
const acGetCompanyCustomerFailure = err => ({ type: GET_COMPANY_CUSTOMER_FAILURE, payload: err })

/**
 * Retrieves a company customer.
 * 
 * @author José Pedro Paludo
 * @returns {Promise} A promise that resolves with the result of the fetch request.
 */
export const acGetCompanyCustomer = companyCustomerId => {
    return dispatchFetchGet(
        `${URLS.COMPANY_CUSTOMER}/${companyCustomerId}`,
        acGetCompanyCustomerBegin,
        acGetCompanyCustomerSuccess,
        acGetCompanyCustomerFailure
    )
}

/**
 * Retrieves the company customers.
 * 
 * @author José Pedro Paludo
 * @returns {Promise} A promise that resolves with the result of the fetch request.
 */

export const acGetCompanyCustomers = (payload) => {

    let url = URLS.COMPANY_CUSTOMER

    if (payload) {
        url = setUrlSearchParams(url, payload)
    }

    return dispatch => (
        dispatch(dispatchFetchGet(
            url,
            acGetCompanyCustomersBegin,
            acGetCompanyCustomersSuccess,
            acGetCompanyCustomersFailure
        ))
            .then(() => {
                if (payload) {
                    dispatch({ type: SET_COMPANY_CUSTOMER_QUERY, payload })
                }
            })
            .catch((err) => {
                console.log("ERROR ON acGetCompanyCustomer")
                console.log(err)
            })
    )
}

